import { type ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import './itinerary-viewer.css';

const DEFAULT_ITINERARY_URL_BASE = 'https://example.com';
const URL_BASE = process.env.RAZZLE_ITINERARY_URL_BASE || DEFAULT_ITINERARY_URL_BASE;

const ItineraryViewer = (): ReactElement | null => {
  const { shareToken } = useParams<{ shareToken?: string }>();
  const ssrHostname = useSelector(
    (state: { applicationState?: { web?: string } }) => state.applicationState?.web,
  );
  const [hostname, setHostname] = useState<string | undefined>(ssrHostname);
  const [frameHeight, setFrameHeight] = useState<number | null>(null);

  useEffect(() => {
    if (window.location.hostname) {
      setHostname(window.location.hostname);
    }
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent): void => {
      if (event.origin !== URL_BASE) return;

      const data = event.data as { type?: unknown; height?: unknown } | null;
      if (data?.type !== 'itinerario:height') return;

      const nextHeight = Number(data.height);
      if (Number.isFinite(nextHeight) && nextHeight > 0) {
        setFrameHeight(nextHeight);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (!hostname || !shareToken) {
    return null;
  }

  const src = `${URL_BASE}/public/itinerary/${encodeURIComponent(shareToken)}?host=${encodeURIComponent(hostname)}`;

  return (
    <div className='itinerary-embed'>
      <iframe
        className='itinerary-embed__frame'
        src={src}
        style={frameHeight ? { height: frameHeight } : undefined}
        title='Itinerario'
      />
    </div>
  );
};

export default ItineraryViewer;
